// extracted by css-extract-rspack-plugin
export default {"cls1":"AffiliationPrompt-cls1_LkI","cls2":"AffiliationPrompt-cls2_9jl AffiliationPrompt-cls1_LkI"};